import { render } from "./QuillInput.vue?vue&type=template&id=65e77fc0&scoped=true"
import script from "./QuillInput.vue?vue&type=script&lang=js"
export * from "./QuillInput.vue?vue&type=script&lang=js"

import "./QuillInput.vue?vue&type=style&index=0&id=65e77fc0&scoped=true&lang=css"

import exportComponent from "/var/www/rizome.dvit.cloud/httpdocs/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-65e77fc0"]])

export default __exports__